import classNames from 'classnames';
import { Link } from 'react-router-dom';
import styles from './NEW_IwLink.module.css';
import { maintainStateKey } from './LocationHelper';

// TODO type as react router link
export const NEW_IwLink = ({
    className,
    to,
    children,
    'data-testid': dataTestId,
    onClick
}: {
    className?: string;
    to: {
        pathname?: string;
        search?: string;
        hash?: string;
    };
    children: React.ReactNode;
    'data-testid'?: string;
    onClick?: () => void;
}) => {
    return (
        <Link
            to={maintainStateKey(to)}
            className={classNames([styles.link, className])}
            data-testid={dataTestId}
            onClick={onClick}
        >
            {children}
        </Link>
    );
};
